export default {
      id: "oc-hcs-usage",
      viewBox: "0 0 1382 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-hcs",
      toString: function () {
        return this.url;
      }
    }